const Footer = () => {
  return (
    <footer className=""> 
    {/* PAA */}
      <div className="">
        <div className="">
        </div>
      </div>
    </footer>
  );
};

export default Footer;
